export default __webpack_public_path__ + "static/media/socket.12a8aadd.png";